<template>
  <div
    class="d-flex flex-row"
  >
    <v-text-field
      v-if="showPhone"
      :value="value"
      :label="labelText"
      v-mask="phoneMask"
      :rules="rules"
      :error-messages="errorMessage"
      type="tel"
      prepend-icon="mdi-phone"
      required
      autocomplete="off"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
      :loading="loading"
    ></v-text-field>
    <v-text-field
      :value="valueNote"
      :counter="counter"
      :rules="rulesNote"
      :label="labelNoteText"
      autocomplete="off"
      :error-messages="errorMessageNote"
      @input="$emit('input-note', $event)"
      @change="$emit('change-note', $event)"
      :loading="loadingNote"
    ></v-text-field>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import phoneMixin from '@/mixins/phoneMixin';

export default {
  name: 'FieldPhoneWithNote',
  directives: { mask },
  mixins: [
    phoneMixin,
  ],
  props: {
    value: {
      type: String,
      default: '',
    },
    valueNote: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    labelNote: {
      type: String,
      default: '',
    },
    counter: {
      type: Number,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    rulesNote: {
      type: Array,
      default: () => [],
    },
    errorMessageNote: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingNote: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    labelText() {
      if (!this.label) {
        return this.lang(this.$store, 'sap/listings.global.filter.hints.phone');
      }
      return this.label;
    },
    labelNoteText() {
      if (!this.labelNote) {
        return this.lang(this.$store, 'sap/listings.global.filter.hints.note');
      }
      return this.labelNote;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.showPhone = true;
    });
  },
	data() {
		return {
			phoneMask: '+380 (##) ###-##-##',
			showPhone: false,
		};
	},
};
</script>

<style scoped>

</style>
